export default __webpack_public_path__ + "static/media/map.7c5f1b5e.png";